import { StarsLink } from '@ps/web-shared-ui';
import classNames from 'clsx';
import { format, isBefore } from 'date-fns';
import React, { useState } from 'react';

import calendar from '../../assets/calendar.png';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../Events.scss';

import EventDetailsModal from './EventDetailsModal';
import EventProgress from './EventProgress';

export interface Table {
  events: EventDetails[];
}

export interface EventDetails {
  title: string;
  type: string;
  dayId: string;
  orderId: string;
  gameType: string;
  startDate: Date;
  endDate: Date;
  registrationEndDate: Date;
  startingStack: string;
  status: string;
  buyin: string;
  icsurl: string;
  sopUrl: string;
  sopDescription: string;
  entry: { cost: string; fee: string; house: string };
  reEntry: { cost: string; fee: string; house: string };
  bounty: { cost: string; fee: string; house: string };
  cap: number;
  prizePool: string;
  entries: string;
  payoutsUrl: string;
  seatDrawUrl: string;
  totalPlayersLeft: string;
  totalEntries: string;
}

export enum ModalType {
  Details = 'Details',
  SeatDraw = 'SeatDraw',
  Prize = 'Prize',
  Winner = 'Winner'
}

export interface SelectedEvent {
  type: ModalType;
  item: EventDetails;
}

const EventDetailsTable: React.FC<Table> = ({ events }) => {
  const [selectedEvent, setSelectedEvent] = useState<SelectedEvent>();

  return (
    <div className={styles.tableContainer}>
      <table className={styles.eventsTable}>
        <thead>
          <tr>
            <th>Time</th>
            <th className={styles.optionalData}>Event Number</th>
            <th>Event</th>
            <th className={styles.optionalData}>Buy-In</th>
            <th className={styles.optionalData}>Starting Stack</th>
            <th className={styles.optionalData}>Registration Closes At</th>
            <th className={styles.optionalData}>Agenda</th>
          </tr>
        </thead>
        <tbody>
          {events.map((item, i) => {
            let formattedPrevStartDate = '';
            let formattedEndDate = '';
            const formattedStartDate = format(item.startDate, 'MMMM dd - EEEE');

            if (i) {
              formattedPrevStartDate = format(events[i - 1].startDate, 'MMMM dd - EEEE');
            }

            if (!isNaN(item.registrationEndDate.getTime())) {
              formattedEndDate =
                isBefore(item.registrationEndDate, new Date()) ||
                isBefore(item.registrationEndDate, item.startDate)
                  ? 'Registration closed'
                  : format(item.registrationEndDate, 'dd.MM.yyyy HH:mm');
            }

            const downloadICS = (
              <StarsLink rel="noopener noreferrer" href={item.icsurl}>
                <div className={styles.calendarIcon}>
                  <img src={calendar} alt="" />
                </div>
              </StarsLink>
            );

            return (
              <React.Fragment key={i}>
                {formattedPrevStartDate !== formattedStartDate && (
                  <tr>
                    <td className={styles.tableSubHeader} colSpan={8}>
                      {formattedStartDate}
                    </td>
                  </tr>
                )}
                <tr>
                  <td>{format(new Date(item.startDate), 'HH:mm')}</td>
                  <td className={styles.optionalData}>{`${item.orderId} ${item.dayId}`}</td>
                  <td>
                    <EventProgress item={item} onClick={setSelectedEvent} />
                    <div className={styles.optionalColumnData}>
                      <strong>Event Number </strong> {`${item.orderId} ${item.dayId}`}
                      <br />
                      <strong>Buy-In </strong> {item.buyin}
                      <br />
                      <strong>Starting stack </strong> {item.startingStack}
                      <br />
                      <strong>Registration closes at </strong>
                      {formattedEndDate}
                      <br />
                      <div className={styles.agendaContainer}>
                        <strong className={styles.agenda}>Agenda</strong> {downloadICS}
                      </div>
                    </div>
                  </td>
                  <td className={styles.optionalData}>{item.buyin}</td>
                  <td className={classNames(styles.centerAlign, styles.optionalData)}>
                    {item.startingStack}
                  </td>
                  <td className={styles.optionalData}>{formattedEndDate}</td>
                  <td className={styles.optionalData}>{downloadICS}</td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      {selectedEvent && (
        <EventDetailsModal {...selectedEvent} onClose={() => setSelectedEvent(undefined)} />
      )}
    </div>
  );
};

export default EventDetailsTable;
